import set from 'lodash/set';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import isNull from 'lodash/isNull';

export const lzIsObject = (input) => {
    return typeof input === 'object' && input !== null;
};

export const lzIsArray = (input) => {
    return Array.isArray(input);
};

export const lzIsNull = (input) => {
    return isNull(input);
};

export const lzIsString = (input) => {
    return typeof input === 'string';
};

export const lzArrayUnique = (arr) => {
    return arr.filter((value, index, self) => self.indexOf(value) === index);
};

export const lzJsonToString = (object) => {
    return JSON.stringify(object);
};

export const lzDeepVarSet = (obj, path, val) => {
    set(obj, path, val);
};

export const lzDeepVarGet = (obj, path, defVal) => {
    return get(obj, path, defVal);
};

export const lzCloneObject = (obj) => {
    return cloneDeep(obj);
};

export const lzGetRecordByComparison = (records, comparison) => {
    const found = records.filter(comparison);
    if (found.length > 0) {
        return found[0];
    }
    return null;
};
